module.exports = __webpack_public_path__ + "static/media/linkedin.a08f59f4.png";